import {
    Box,
    Grid,
    Typography,
    SxProps,
    Theme,
} from "@mui/material";
import startupIncubatorHeaderImg from "../assets/startup-incubator-header.webp";
import tomoveImg from "../assets/tomove.webp";
import womatImg from "../assets/womat.webp";
import PageTitle from "../components/PageTitle";
import PageContent from "../components/PageContent";
import { useIsMobile } from "../hooks";
import { useTranslation } from "react-i18next";
import StartupRow from "../components/StartupRow";

const StartupIncubatorPageStyle: Record<string, SxProps<Theme>> = {
    headerImage: {
        position: "relative",
        maxHeight: "200px",
        img: {
            height: "200px",
            width: "100%",
            objectFit: "cover",
        },
    },
    headerImageMobile: {
        position: "relative",
        maxHeight: "400px",
        img: {
            height: "400px",
            width: "100%",
            objectFit: "cover",
        },
    },
    headerTextContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        paddingLeft: "20px",
        paddingRight: "20px",
    },
    headerText: {
        background: "#0000007D",
        fontSize: "1.3rem",
    },
    headerTextMobile: {
        fontSize: "18px",
        textAlign: "center",
        background: "#37314A",
        padding: "20px",
        borderRadius: "10px",
    },
};

const StartupIncubatorPage = () => {
    const { isMobile } = useIsMobile();
    const { t } = useTranslation();

    return (
        <>
            <PageTitle>Startup Incubator</PageTitle>
            <PageContent>
                <Grid
                    container
                    spacing={isMobile ? 0 : 4}
                    sx={{ alignItems: "center" }}
                >
                    {!isMobile && (
                        <Grid item md={12}>
                            <Box
                                sx={
                                    isMobile
                                        ? StartupIncubatorPageStyle.headerImageMobile
                                        : StartupIncubatorPageStyle.headerImage
                                }
                            >
                                <Box sx={StartupIncubatorPageStyle.headerTextContainer}>
                                    <Typography sx={StartupIncubatorPageStyle.headerText}>
                                        {t("startup.header")}
                                    </Typography>
                                </Box>
                                <img src={startupIncubatorHeaderImg} alt="Startup incubator header" />
                            </Box>
                        </Grid>
                    )}

                    {isMobile && (
                        <Grid item md={12}>
                            <Typography sx={StartupIncubatorPageStyle.headerTextMobile}>
                                {t("startup.header")}
                            </Typography>
                        </Grid>
                    )}

                    <StartupRow 
                        image={tomoveImg}
                        title="To-Move" 
                        text={[
                            t("startup.1.desc.1"),
                            t("startup.1.desc.2"),
                            t("startup.1.desc.3"),
                        ]}
                    />

                    <StartupRow 
                        image={womatImg} 
                        title="WoMat" 
                        text={[
                            t("startup.2.desc.1"),
                            t("startup.2.desc.2"),
                            t("startup.2.desc.3"),
                            t("startup.2.desc.4"),
                        ]}
                    />
                </Grid>
            </PageContent>
        </>
    );
};

export default StartupIncubatorPage;
